<p-toast></p-toast>
<div class="site-content px-6 py-6" *ngIf="experience">

    <div class="container">
        <div class="header-experience flex flex-row align-items-center justify-content-between">
            <div class="section-title flex flex-row align-items-center">
                <div (click)="goBack()" class="experience-back cursor-pointer"><i class="pi pi-arrow-left text-2xl"></i>
                </div>
                <h1 class="experience-title ml-6 text-4xl font-bold">{{experience.details.title}}</h1>

            </div>
            <div class="section-interactive">
                <a class="text-sm " href="#">
                    <i class=" pi pi-share-alt text-sm"></i> <span class="ml-2 text-sm">Condividi</span>
                </a>
                <a class="text-sm ml-5 " href="#">
                    <i class="pi pi-heart text-sm"></i> <span class="ml-2 text-sm">Salva</span>
                </a>
            </div>
        </div>
        <div class="carousel-experience" [ngClass]="sortedMedias.length > 3 ? '-mx-6' : ''" *ngIf="experience && sortedMedias.length > 0">

            <div class="carousel-images" 
                 [ngClass]="sortedMedias.length > 3 ? 'show-arrows' : 'hide-arrows'"
                 appCarouselDrag
                 [carouselRef]="experienceCarousel"
                 [enableDrag]="sortedMedias.length > 3">
                <p-carousel 
                    #experienceCarousel
                    [value]="sortedMedias" 
                    [numVisible]="3" 
                    [numScroll]="1"
                    [responsiveOptions]="responsiveOptionsExperience"
                    [showNavigators]="sortedMedias.length > 3"
                    [showIndicators]="false">
                    <ng-template let-media pTemplate="item">
                        <img *ngIf="media.mediaUrl"
                            [appImageFallback]="getImageUrl(media.mediaUrl, media.mediaType === 'mainCover')" />
                    </ng-template>
                </p-carousel>
            </div>
        </div>
        <div class="content-experience flex flex-column md:flex-row align-items-stretch justify-content-start mt-5">
            <div class="content-experience-full w-full md:w-8">
                <div class="header-experience-full">
                    <ol class="experience-info list-none p-0 m-0">
                        <li *ngIf="experience.details.place && experience.details.place.city"
                            class="font-bold inline-block text-lg mr-5"> <i class=" pi pi-map-marker"></i> {{
                            experience.details.place.city }}</li>
                        <li *ngIf="experience.details.duration" class="font-bold inline-block text-lg mr-5"><i
                                class=" pi pi-clock "></i>
                            {{ formatDuration(experience.details.duration) }}
                        </li>
                        <li *ngIf="spklangTags!.length > 0" class="font-bold inline-block text-lg">
                            <i class="pi pi-comment"></i>

                            <ng-container *ngFor="let lang of spklangTags; let last = last">
                                <span> {{ lang.name }}</span>
                                <span *ngIf="!last">, </span>
                            </ng-container>
                        </li>
                    </ol>
                    <ng-container *ngIf="allTypeTags && allTypeTags.length > 0">
                        <div class="experience-tags list-none p-0 mt-2">
                            <span class="text-base tag">
                                {{ tagList }}
                            </span>
                        </div>
                    </ng-container>

                </div>
                <div *ngIf="companies?.name"
                    class="winery-experience-full flex align-content-start align-items-center justify-content-start border-y-1 py-5 my-5 border-gray-300">
                    <div class="logo-winery">
                        <img *ngIf="getWineryLogoUrl()" [appImageFallback]="getWineryLogoUrl()"
                            [alt]="companies?.name || 'Winery logo'"
                            style="width:80px;height:80px;object-fit:cover;border-radius:50%;" />
                        <div *ngIf="!getWineryLogoUrl()"
                            style="width:80px;height:80px;background:#D9D9D9;border-radius:50%;"></div>
                    </div>
                    <div class="title-winery pl-5">
                        <p class="text-xl mb-2 mt-0	">{{companies?.name}} </p>
                        <p class="text-base my-0">{{experience.details.place.city}}</p>
                    </div>
                </div>
                <div class="description-experience-full" *ngIf="experience.details.description">
                    <h2 class="text-xl font-bold">Descrizione</h2>
                    <div class="description-content pb-6">
                        <div class="text-lg" [innerHTML]="experience.details.description"></div>
                    </div>
                </div>
                <div class="products-experience-full" *ngIf="experience.products && experience.products.length > 0">
                    <h2 class="text-xl font-bold">Cosa degusterai</h2>
                    <div class="products-list flex pb-6">
                        <div class="product-single-card shadow-4 border-round-2xl mr-3 pt-0"
                            *ngFor="let product of experience.products; let first = first">
                            <p class="text-center border-bottom-1 border-bluegray-100 pb-2	pt-0 px-4"> <img class="w-4"
                                    *ngIf="product.cover && product.cover.urls" [src]="product.cover.urls.vv" /></p>
                            <div class="px-3">
                                <p class="text-base my-0 font-bold"> {{ product.name }}</p>
                                <p class="text-sm mt-1">{{ product.wine_type }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="experience.details.summary;" class="activity-experience-full">
                    <h2 class="text-xl font-bold">Cosa è incluso</h2>
                    <div class="activity-list pb-6">
                        <div class="text-lg" [innerHTML]="experience.details.summary"></div>
                    </div>
                </div>
                <div class="services-experience-full" *ngIf="experienceService && experienceService.length > 0">
                    <h2 class="text-xl font-bold">Servizi della struttura</h2>
                    <div class="services-list flex pb-6">
                        <div class="experience-service list-none p-0 flex flex-wrap">

                            <ng-container *ngFor="let service of experienceService">
                                <div class="mb-2">
                                    <span class="mr-3"><img [src]="service.icon" class="icon w-1rem"></span>
                                    <span class="text-lg mr-5">{{ service.name }}
                                    </span>
                                </div>
                            </ng-container>

                        </div>
                    </div>
                </div>
                <div class="map-experience-full" *ngIf="experience.details.place && experience.details.place.lat && experience.details.place.lng">
                    <h2 class="text-xl font-bold">Come raggiungerci</h2>
                    <app-experience-map-v2 [experience]="experience" [latitude]="+experience.details.place.lat"
                        [longitude]="+experience.details.place.lng"></app-experience-map-v2>



                </div>
                <!-- Sezione Recensioni nascosta finché non ci sono dati -->
                <!-- <div class="reviews-experience-full" *ngIf="false">
                    <h2 class="text-xl font-bold">Recensioni</h2>

                </div> -->
                <div class="reviews-experience-full" *ngIf="experience.products && experience.products.length > 0">
                    <h2 class="text-xl font-bold">Potrebbe interessarti anche</h2>
                    <div class="products-list flex pb-5">
                        <div class="product-single-card shadow-4 border-round-2xl mr-3 pt-0 pb-2"
                            *ngFor="let product of experience.products; let first = first">
                            <p class="text-center border-bottom-1 border-bluegray-100 pb-2	pt-0 px-4"> <img
                                    *ngIf="product.cover && product.cover.urls" class="w-4"
                                    [src]="product.cover.urls.vv" /></p>
                            <div class="px-3">
                                <p class="text-base my-0 font-bold"> {{ product.name }}</p>
                                <p class="text-sm mt-1">{{ product.wine_type }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-experience-book w-full md:w-4 md:ml-8 mt-6 md:mt-0">
                <div
                    class="inside-experience-book max-h-full md:sticky md:top-6 shadow-4 border-round-2xl pt-5 px-4 pb-4 pb-2">
                    <div class="experience-price font-bold">
                        <span style="font-weight:800;" class="text-6xl"> {{
                            formatCurrencyCents(experience.prices[0]?.price || 0)
                            }}</span> /
                        {{maxLenghtText(experience.prices[0]?.priceDescription || '', 30)}}
                    </div>
                    <div class="experience-instant-booking mt-2" *ngIf="experience.details.instantBooking !== false">
                        <span class="text-sm border-1 border-200 px-2 py-1 border-round-sm"><i
                                class="pi pi-bolt text-xs"></i> Instant booking</span>

                    </div>

                    <div class="experience-booking-form mt-5 relative">
                        <div class="reset-fields z-5">
                            <a class="text-xs cursor-pointer underline" *ngIf="checkoutForm.dirty"
                                (click)="resetForm()">Svuota tutti i campi</a>
                        </div>
                        <p-tabView (onChange)="onTabChange($event)">
                            <p-tabPanel header="Prenota"></p-tabPanel>
                            <p-tabPanel header="Regala"></p-tabPanel>
                        </p-tabView>

                        <form class="form-book mt-3" #checkoutForm="ngForm" [ngClass]="{'form-gift': !isReservation}"
                            (ngSubmit)="onSubmit(checkoutForm)">
                            <div class="form-wrapper">
                                <!-- Campo Lingua, visibile solo per Prenota -->
                                <div class="form-group" *ngIf="isReservation">
                                    <ng-container *ngIf="allTypeTags && allTypeTags.length > 0;">
                                        <p-dropdown id="language" class="form-element" name="language"
                                            [(ngModel)]="selectedLanguage" [options]="spklangTags"
                                            (onChange)="onGetAvailabilitiesClick($event)" optionLabel="name"
                                            [showClear]="true" placeholder="Lingua" [filter]="false"
                                            [panelStyleClass]="'language-dropdown-panel'"></p-dropdown>
                                    </ng-container>
                                </div>

                                <!-- Campo Data, visibile solo per Prenota -->
                                <div class="form-group" *ngIf="isReservation">
                                    <p-calendar dateFormat="dd/mm/yy" [disabled]="!isLanguageSelected"
                                        [showOtherMonths]="false" [selectOtherMonths]="false"
                                        (onMonthChange)="onMonthChange($event)" (onFocus)="onCalendarClick()"
                                        (onSelect)="onDateSelect($event)" id="date" name="date" class="form-element"
                                        [(ngModel)]="selectedDate" placeholder="Data" [disabledDates]="disabledDates"
                                        [ngClass]="{ 'disabled-date': !isLanguageSelected }">
                                        <ng-template pTemplate="date" let-date>
                                            <span [ngClass]="getDateClass(date)"
                                                [class.selected-date]="checkIfDateSelected(date)">
                                                {{ date.day }}
                                            </span>
                                        </ng-template>
                                    </p-calendar>
                                </div>

                                <!-- Campo Ora, visibile solo per Prenota -->
                                <div class="form-group" *ngIf="isReservation">
                                    <ng-container *ngIf="allTypeTags && allTypeTags.length > 0;">
                                        <p-dropdown id="time" name="time" class="form-element"
                                            [(ngModel)]="selectedTime" [options]="availableTimes" optionLabel="label"
                                            [showClear]="true" placeholder="Ora" [disabled]="!isLanguageAndDateSelected"
                                            (onChange)="onTimeSelect($event)" [filter]="false"
                                            [panelStyleClass]="'time-dropdown-panel'"
                                            [ngClass]="{ 'disabled-time': !isLanguageAndDateSelected }"></p-dropdown>
                                    </ng-container>
                                </div>

                                <!-- Campo Persone, visibile per entrambe le schede -->
                                <div class="form-group">
                                    <ng-container *ngIf="allTypeTags && allTypeTags.length > 0;">
                                        <app-people-dropdown #peopleDropdown
                                            [isLanguageDateAndTimeSelected]="isLanguageDateAndTimeSelected"
                                            (totalPriceChange)="updatePeopleTotalPrice($event)"
                                            [experience]="experience" [isReservation]="isReservation"
                                            [timePeopleInfo]="timePeopleInfo" (isValidChange)="updateIsValid($event)"
                                            (numberOfPeopleChange)="handleNumberOfPeopleChange($event)"
                                            (labelCountsChange)="handleLabelCountsChange($event)"></app-people-dropdown>
                                    </ng-container>
                                </div>

                                <!-- Campo Extra, visibile solo per Prenota -->
                                <div class="form-group" *ngIf="isReservation">
                                    <ng-container *ngIf="allTypeTags && allTypeTags.length > 0;">
                                        <app-extra-dropdown #extraDropdown
                                            [isLanguageDateAndTimeSelected]="isLanguageDateAndTimeSelected"
                                            (totalPriceChange)="updateExtraTotalPrice($event)" [experience]="experience"
                                            (isValidChange)="updateIsValid($event)"
                                            [isExtraDisabled]="isExtraDisabled"></app-extra-dropdown>
                                    </ng-container>
                                </div>

                                <!-- Totale Prezzo -->
                                <div class="form-group total-price-group">
                                    <span class="total-price font-bold text-xl">Tot. {{
                                        formatCurrencyCents(combinedTotalPrice) }}</span>
                                </div>
                            </div>

                            <div class="form-checkout pt-4 mb-4">
                                <p-button type="submit"
                                    class="btn-checkout border-round-3xl text-base border-none font-bold"
                                    label="Checkout" [disabled]="!isValid"></p-button>
                            </div>

                            <!-- Error message for availability errors -->
                            <div *ngIf="isAvailabilityErrorVisible" class="error-message">
                                {{ availabilityErrorMessage || 'Si è verificato un errore. Riprova più tardi.' }}
                            </div>

                            <!-- Riepilogo del form, visibile solo per Prenota -->
                            <div class="form-summary pt-3 font-bold flex flex-row flex-wrap justify-content-start line-height-3">
                                <!-- First LABEL price description (shown only once) -->
                                <div *ngIf="getFirstLabelPrice()">
                                    <span><i class="pi pi-check mr-2 font-bold"></i></span>
                                    <span>{{ getFirstLabelPrice()?.priceTitle || 'Prezzo' }}:
                                        {{ formatCurrencyCents(getFirstLabelPrice()?.price || 0) }}</span>
                                </div>

                                <!-- Extra LABEL prices (position > 0) -->
                                <div *ngFor="let price of getExtraLabelPrices()">
                                    <span class="mx-2">-</span>
                                    <span>{{ price.priceTitle || 'Prezzo' }}:
                                        {{ formatCurrencyCents(price.price || 0) }}</span>
                                </div>

                                <!-- EXTRA prices -->
                                <div *ngFor="let price of getExtraPrices()">
                                    <span class="mx-2">-</span>
                                    <span>{{ price.priceTitle || 'Extra' }}:
                                        {{ formatCurrencyCents(price.price || 0) }}</span>
                                </div>
                            </div>
                        </form>


                    </div>
                </div>

            </div>
        </div>

    </div>

</div>
<!-- LOADER -->
<div class="site-content px-6 py-6" *ngIf="!experience">

    <div class="container border-round border-1 surface-border p-4 surface-card">
        <div class="flex mb-3">
            <p-skeleton shape="circle" size="4rem" styleClass="mr-2"></p-skeleton>
            <div>
                <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton height=".5rem"></p-skeleton>
            </div>
        </div>
        <p-skeleton width="100%" height="150px"></p-skeleton>
        <div class="flex justify-content-between mt-3">
            <p-skeleton width="4rem" height="2rem"></p-skeleton>
            <p-skeleton width="4rem" height="2rem"></p-skeleton>
        </div>
    </div>
</div>